import lambdaUtil from 'APP_ROOT/components/aws/lambda/lambdaUtil';

export function fetchAccountIdentities(stage) {
    return lambdaUtil.getFaces(stage)
        .then(payload => {
            const { listIdentities } = payload;
            // combine both arrays together
            return [...listIdentities.knownIdentities, ...listIdentities.unknownIdentities];
        }).then(identitiesArray => {
            return identitiesArray.map(it => ({
                identityId: it.identityId,
                name: it.name,
                profileImageUrl: it.profileFace && it.profileFace.secureImageUrl,
            }));
        });
}

export function fetchDetailedIdentity(stage, identityId) {
    return lambdaUtil.lookupIdentities(stage, [ Number(identityId) ], true)
        .then(payload => {
            const { lookupIdentities } = payload;
            return lookupIdentities.identities.map(it => ({
                ...it,
                profileImageUrl: it.profileFace && it.profileFace.secureImageUrl,
            }));
        });
}

export function fetchIdentitiesById(stage, identityIds) {
    // TODO: instead of looking at stage here, check user attribute "demo" and get from s3
    if (/^showcase/.test(stage)) {
        return showcaseLookupIdentities();
    }
    return lambdaUtil.lookupIdentities(stage, identityIds)
        .then(payload => {
            const { lookupIdentities } = payload;
            return lookupIdentities.identities.map(it => ({
                ...it,
                profileImageUrl: it.profileFace && it.profileFace.secureImageUrl,
            }));
        });
}

const showcaseLookupIdentities = () => {
    return Promise.resolve([{
        identityId: 270,
        profileImageUrl: '/images/face_dan.jpg',
        name: 'Dan',
    }, {
        identityId: 738,
        profileImageUrl: '/images/face_piotr.jpg',
        name: 'Bob',
    }, {
        identityId: 16,
        profileImageUrl: '/images/face_stefan.jpg',
        name: 'Steve',
    }, {
        identityId: 29,
        profileImageUrl: '/images/face_charles.jpg',
    }]);
}
